import createQuoteRequestBasic,
{ 
    deleteCartAfterQuoteRequest,
    acceptFinalQuote,
    changeQuotationCartLineItemQuantity,
    deleteQuotationCartLineItem,
    addDirectDiscount,
    createFinalQuotation,
    changeQuoteRequestState,
    setLineItemPrice
} from './ct/useQuoteTools';

function createQuoteRequest(cart, comment, quoteRequestSuccessCallback) {
    createQuoteRequestBasic(cart, comment, quoteRequestSuccessCallback)
}

const useQuoteTools = () => {
    return {
        createQuoteRequest,
        deleteCartAfterQuoteRequest,
        acceptFinalQuote,
        changeQuotationCartLineItemQuantity,
        deleteQuotationCartLineItem,
        addDirectDiscount,
        createFinalQuotation,
        changeQuoteRequestState,
        setLineItemPrice
    }
}

export default useQuoteTools;